module.exports = __webpack_public_path__ + "img/main-facility-courtyard.c690c3f1.jpg";